import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=2c5f96d3&scoped=true&"
import script from "./CheckList.vue?vue&type=script&lang=js&"
export * from "./CheckList.vue?vue&type=script&lang=js&"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=2c5f96d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f96d3",
  null
  
)

export default component.exports